import { Hyper, HyperElements } from "@juspay-tech/react-hyper-js";
import React, { createContext, useContext, useState } from "react";

interface HyperPaymentContextValue {
  savedHyper?: Hyper;
  savedElements?: HyperElements;
  setSavedHyper: (hyper: Hyper) => void;
  setSavedElements: (elements: HyperElements) => void;
}

const HyperPaymentContext = createContext<HyperPaymentContextValue | undefined>(
  undefined,
);

export const HyperPaymentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [savedHyper, setSavedHyper] = useState<Hyper>();
  const [savedElements, setSavedElements] = useState<HyperElements>();

  return (
    <HyperPaymentContext.Provider
      value={{
        savedHyper,
        savedElements,
        setSavedHyper,
        setSavedElements,
      }}>
      {children}
    </HyperPaymentContext.Provider>
  );
};

export const useHyperPaymentContext = (): HyperPaymentContextValue => {
  const context = useContext(HyperPaymentContext);
  if (!context) {
    throw new Error(
      "useHyperPaymentContext must be used within a HyperPaymentProvider",
    );
  }
  return context;
};
